import React from 'react'
import root from '../../shared/utils'

export default React.createClass({

  render: function(){
  let newStructure
  let greenCheckFlat = root + '/common/latest/images/consumer/order-process-icons/green-check.png'
  let grayCheckFlat = root + '/common/latest/images/consumer/order-process-icons/gray-check.png'

  let headerClass = null;
  let borderClass = null;
  if(this.props.fullComponent) {
    headerClass = 'pull-left'
    borderClass = 'col-xs-12'
  }
  else {
    headerClass = 'pull-left hidden' 
    borderClass = 'col-xs-12 hidden'
  }

  let edit;
    if(this.props.hideAllButtons !== true && this.props.fullComponent === true){
      edit = <a id='edit2' className='pull-down-xs-3' style={{float: 'right', textDecoration: 'underline'}} onClick={this.props.openUpgradeServiceModal}>Edit</a>
    }
  switch (this.props.packageType) {

    case 'basic':
    case 'BASIC':
    case 'budget': {
      newStructure =
      <div>
        <div className='pull-left' style={{width: '50%'}}>
          <div className='row' style={{width: '80%', float: 'right'}}>
            <div className='col-xs-12'>
              <img style={{marginRight: 5}} className='pull-left' role='presentation' src={greenCheckFlat} />
              <p className='pull-left'>Mow</p>
            </div>
            <div className='col-xs-12'>
              <img style={{marginRight: 5}} className='pull-left' role='presentation' src={greenCheckFlat} />
              <p className='pull-left'>Trim</p>
            </div>
            <div className='col-xs-12'>
              <img style={{marginRight: 5}} className='pull-left' role='presentation' src={greenCheckFlat} />
              <p className='pull-left'>Blow</p>
            </div>
          </div>
        </div>
        <div className='pull-left' style={{width: '50%'}}>
          <div className='row' style={{width: '101%', float: 'right'}}>
           <div className='col-xs-12'>
              <img style={{marginRight: 5}} className='pull-left' role='presentation' src={grayCheckFlat} />
              <p className='pull-left'style={{textDecoration: 'line-through', color: '#c7c7c7'}}>Edge</p>
           </div>
           <div className='col-xs-12'>
              <img style={{marginRight: 5}} className='pull-left' role='presentation' src={grayCheckFlat} />
              <div className='pull-left' style={{width: 100}}>
                <div style={{textDecoration: 'line-through', color: '#c7c7c7'}}>Maintain Flowerbeds</div>
              </div> 
           </div>
          </div>
        </div>
      </div>
      break
    }
    case 'PREMIUM':
    case 'Full-Service':
    case 'premium': {
      newStructure =
        <div>
        <div className='pull-left' style={{width: '50%'}}>
          <div className='row' style={{width: '80%', float: 'right'}}>
            <div className='col-xs-12'>
              <img style={{marginRight: 5}} className='pull-left' role='presentation' src={greenCheckFlat} />
              <p className='pull-left'>Mow</p>
            </div>
            <div className='col-xs-12'>
              <img style={{marginRight: 5}} className='pull-left' role='presentation' src={greenCheckFlat} />
              <p className='pull-left'>Trim</p>
            </div>
            <div className='col-xs-12'>
              <img style={{marginRight: 5}} className='pull-left' role='presentation' src={greenCheckFlat} />
              <p className='pull-left'>Blow</p>
            </div>
          </div>
        </div>
        <div className='pull-left' style={{width: '50%'}}>
          <div className='row' style={{width: '101%', float: 'right'}}>
           <div className='col-xs-12'>
              <img style={{marginRight: 5}} className='pull-left' role='presentation' src={greenCheckFlat} />
              <p className='pull-left'>Edge</p>
           </div>
           <div className='col-xs-12'>
              <img style={{marginRight: 5}} className='pull-left' role='presentation' src={greenCheckFlat} />
              <div className='pull-left' style={{width: 100}}>
                <div>Maintain Flowerbeds</div>
              </div> 
           </div>
          </div>
        </div>
      </div>
      break
    }
    default:
      break
  }
  return (
    <div className='row'>
      <hr style={{borderColor: '#c7c7c7', marginRight: -15, marginLeft: -15}}/>
      <div className={borderClass} style={{fontSize: 24}}>
        <b className={headerClass}>Service Plan: </b>
        <div className={headerClass} style={{paddingLeft: 14}}>{this.props.name}</div>
      </div>
      <div className='col-xs-12 pull-down-xs-2'>
        <div style={{width: '80%', margin: 'auto', fontSize: 16}}>
          {newStructure}
        </div>
        {edit}
      </div>
    </div>
  )
}
})



// WEBPACK FOOTER //
// ./src/components/modals/components/service-plan.jsx